import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-sand/5">
      <div className="container py-20 text-center">
        <h1 className="text-6xl font-bold text-wood mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-4">Page Not Found</h2>
        <p className="text-neutralText mb-8 max-w-lg mx-auto">
          We couldn't find the page you're looking for. It might have been moved or deleted.
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-ghost-outline"
            aria-label="Go back to previous page"
          >
            Go Back
          </button>
          <Link to="/" className="btn btn-wood">
            Return Home
          </Link>
        </div>
        
        <div className="mt-12">
          <h3 className="text-lg font-semibold mb-4">Popular Pages</h3>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/services" className="text-wood hover:underline">
              Our Services
            </Link>
            <Link to="/portfolio" className="text-wood hover:underline">
              Portfolio
            </Link>
            <Link to="/locations" className="text-wood hover:underline">
              Service Locations
            </Link>
            <Link to="/contact" className="text-wood hover:underline">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}